import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edge-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['../../shared/swiper.scss', './home-carousel.component.scss']
})
export class HomeCarouselComponent implements OnInit {
  slides = [
    {
      image: '1-fbl.jpg',
      caption: 'Draw up your own plays'
    },
    {
      image: '2-scr.jpg',
      caption: 'Split the defense'
    },
    {
      image: '3-fbl.jpg',
      caption: 'Read the overhang'
    },
    {
      image: '4-scr.jpg',
      caption: 'Precision player moves and timing'
    },
    {
      image: '5-fbl.jpg',
      caption: 'Customize uniforms etc.'
    }
  ];

  ngOnInit() {
    setInterval(() => {
      this.next();
    }, 5000);
  }

  previous() {
    this.slides.unshift(this.slides.pop());
  }

  next() {
    this.slides.push(this.slides[0]);
    this.slides.splice(0, 1);
  }
}
